

import { SubDomain } from "../../../SubDomain.js";
import Option from "./Option.js";

export default class OptionsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, Option.MODEL_NAME);
    this.storage = storage;
  }

  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        var option = new Option(this.domain, item);
        return option;
      }
    }

    return new Option(this.domain);
  }
  
  findNotesMajor() {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      var option = new Option(this.domain, item);
      if (option.isRemark() && option.isMajor()) {
        return option;
      }
    }

    return new Option(this.domain);
  }
  
  findNotesMinor() {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      var option = new Option(this.domain, item);
      if (option.isRemark() && option.isMinor()) {
        return option;
      }
    }

    return new Option(this.domain);
  }
}